import envSense from "env-sense"
import {Platform} from "react-native"

// All React Native Web components have z-index: 0 which causes previous elements to be below them.
// This is not how it works on Android, which therefore is most likely a bug.

const {isServer} = envSense()

if (!isServer && Platform.OS == "web") {
  const style = document.createElement("style")

  style.type = "text/css"
  style.innerHTML = "[class^=\"css-\"] { z-index: auto; }"

  document.getElementsByTagName("head")[0].appendChild(style)
}
